<template>
  <v-app :class="currentTheme === 'dark' ? 'theme-dark' : 'theme-light'">

    <!-- Menu dinàmic: lateral (drawer) -->
    <v-navigation-drawer
      v-if="!hideClientNavigation && menuEspecial === 1"
      v-model="drawer"
      app
      width="280"
      class="client-menu-drawer"
      :color="currentTheme === 'dark' ? '#1e1e1e' : 'white'"
      elevation="2"
    >
      <v-list-subheader class="font-weight-bold text-uppercase">
        <img :src="logo_client" class="client-logo" style="margin-left: 10px;" />
      </v-list-subheader>

      <v-list density="comfortable">
        <template v-for="(item, idx) in safeMenu" :key="`${item.label}-${idx}`">

          <!-- ITEM LINK -->
          <v-list-item
            v-if="item.type === 'link'"
            :to="toRoute(item)"
            :value="itemValue(item)"
            link
            @click="drawer = false"
          >
            <template #prepend>
              <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
            </template>

            <v-list-item-title>{{ item.label }}</v-list-item-title>
          </v-list-item>

          <!-- ITEM GROUP -->
          <v-list-group
            v-else-if="item.type === 'group'"
            :value="item.label"
          >
            <template #activator="{ props }">
              <v-list-item v-bind="props">
                <template #prepend>
                  <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                </template>

                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item>
            </template>

            <!-- CHILDREN -->
            <v-list-item
              v-for="(child, cidx) in item.children"
              :key="`${item.label}-${child.label}-${child.params?.shop ?? cidx}`"
              :to="toRoute(child)"
              :value="itemValue(child, item)"
              link
              @click="drawer = false"
            >
              <template #prepend>
                <v-icon v-if="child.icon">{{ child.icon }}</v-icon>
              </template>

              <v-list-item-title>{{ child.label }}</v-list-item-title>
            </v-list-item>
          </v-list-group>

        </template>
      </v-list>
    </v-navigation-drawer>

    <div class="header-logo" :style="headerLogoStyle"></div>

    <!-- Header transparent -->
    <v-app-bar
      app
      flat
      height="80"
      color="transparent"
      class="header-bar"
      :style="{
        transform: showHeader ? 'translateY(0)' : 'translateY(-100%)',
        transition: 'transform 0.3s ease'
      }"
    >
      <v-spacer />
      <v-spacer />

      <!-- Toggle Clar/Fosc -->
      <div class="justify-center theme-toggle" @click="toggleTheme">
        <span :class="['toggle-label', currentTheme === 'light' ? 'active' : '']">
          MODO CLARO
        </span>

        <div class="toggle-switch" :class="{ dark: currentTheme === 'dark' }">
          <v-icon class="toggle-icon">
            {{ currentTheme === 'light' ? 'mdi-white-balance-sunny' : 'mdi-weather-night' }}
          </v-icon>
        </div>

        <span :class="['toggle-label', currentTheme === 'dark' ? 'active' : '']">
          MODO OSCURO
        </span>
      </div>

      <v-spacer />

      <!-- Botons Admin -->
      <div class="d-flex align-center gap-buttons" v-if="showMenu">
        <v-btn
          variant="outlined"
          color="#00C2A8"
          class="font-weight-bold"
          density="compact"
          height="30"
          min-width="100"
          size="small"
          :to="{ path: '/dashboard' }"
        >
          Admin
        </v-btn>

        <v-btn
          variant="outlined"
          color="#00C2A8"
          class="font-weight-bold"
          density="compact"
          height="30"
          min-width="100"
          size="small"
          :to="{ path: '/cliente' }"
        >
          Web cliente
        </v-btn>
      </div>

      <!-- Menú bàsic -->
      <v-btn
        variant="plain"
        class="menu-link"
        @click="drawer = !drawer"
        v-if="!hideClientNavigation && menuEspecial === 1"
      >
        Área de cliente
      </v-btn>

      <v-btn
        variant="plain"
        class="menu-link"
        :to="campListRoute"
        v-if="!hideClientNavigation && menuEspecial === 0"
      >
        Campañas
      </v-btn>

      <v-btn
        variant="plain"
        class="menu-link"
        :to="estadistiquesRoute"
        v-if="!hideClientNavigation && menuStats === 1"
      >
        Estadísticas
      </v-btn>

      <v-btn
        variant="plain"
        class="menu-link"
        to="/cliente/Estudios"
        v-if="!hideClientNavigation && menuStats === 1"
      >
        Estudios
      </v-btn>

      <v-btn
        icon
        size="small"
        variant="plain"
        class="menu-link"
        @click="logout"
        title="Salir"
      >
        <v-icon size="20">mdi-logout</v-icon>
      </v-btn>

      <!-- Botó control menú admin -->
      <v-btn
        icon
        size="small"
        color="#336699"
        class="ml-2"
        @click="showMenu = !showMenu"
        v-if="userRole === 'admin'"
      >
        <v-icon>{{ showMenu ? 'mdi-menu-open' : 'mdi-menu' }}</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Logo del client -->
    <div class="client-logo-wrapper">
      <img :src="logo_client" alt="" class="client-logo" />
    </div>

    <!-- Contingut -->
    <v-main app style="margin-top: 20px;">
      <v-container
        v-if="breadcrumbs.length"
        class="py-1 px-4 bg-grey-lighten-3"
        fluid
      >
        <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
      </v-container>

      <v-container fluid class="pa-4">
        <router-view
          :key="route.name + '-' + (route.params.shop ?? '') + '-' + (route.params.desc ?? '')"
        />
      </v-container>
    </v-main>

    <!-- Peu de pagina -->
    <v-footer app height="72" class="footer-bar" :elevation="0">
      <v-container fluid class="pa-0">
        <v-row class="ma-0 align-center footer-content" no-gutters>
          <v-col cols="12" sm="4" class="d-none d-sm-flex justify-start px-4"></v-col>

          <v-col cols="12" sm="4" class="d-flex justify-center">
            <img
              :src="footerLogoUrl"
              alt="Logo peu de pàgina"
              class="footer-logo"
              height="30px"
            />
          </v-col>

          <v-col cols="12" sm="4" class="d-flex justify-end px-4">
            <a
              href="https://www.traycco.es"
              target="_blank"
              rel="noopener"
              class="footer-link"
            >
              www.traycco.es
            </a>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { computed, ref, onMounted, onUnmounted, watch } from 'vue'
import { useTheme } from 'vuetify'

const drawer = ref(false)
const showMenu = ref(false)

const route = useRoute()
const router = useRouter()
const theme = useTheme()

const currentTheme = computed(() => theme.global.name.value)

const logo_client = ref('')
const menuEspecial = ref(0)
const menuStats = ref(1)
const sessionShopId = ref('')
const clientMenuItems = ref([])
const userRole = ref('')

// Nou: controla si el login ve per token de campanya
const isCampaignTokenLogin = ref(false)

const isCampaignTokenRoute = computed(() => {
  return route.name === 'CampListToken'
    || (route.path.startsWith('/cliente/') && !!route.params.idClient && !!route.params.token)
})

const hideClientNavigation = computed(() => {
  return isCampaignTokenLogin.value || isCampaignTokenRoute.value
})

const footerLogoUrl = '/images/Traycco_Negre.png'
const headerLogoStyle = {
  backgroundImage: "url('/images/logo_fons.png')"
}

const showHeader = ref(true)
const lastScrollY = ref(0)

const campListRoute = computed(() => {
  return sessionShopId.value
    ? `/cliente/CampList/${sessionShopId.value}`
    : '/cliente/CampList'
})

const estadistiquesRoute = computed(() => '/cliente/Estadistiques')

const breadcrumbs = computed(() => {
  return (route.meta?.breadcrumb ?? []).map(item => ({
    title: item.text,
    disabled: !item.to,
    to: item.to || undefined
  }))
})

function handleScroll() {
  const currentScrollY = window.scrollY

  if (currentScrollY <= 20) {
    showHeader.value = true
    lastScrollY.value = currentScrollY
    return
  }

  if (currentScrollY > lastScrollY.value) {
    showHeader.value = false
  } else if (currentScrollY < lastScrollY.value) {
    showHeader.value = true
  }

  lastScrollY.value = currentScrollY
}

function toggleTheme() {
  theme.global.name.value = currentTheme.value === 'light' ? 'dark' : 'light'
}

/* ============================================================
   Normalització del menú
============================================================ */
const safeMenu = computed(() => {
  const items = Array.isArray(clientMenuItems.value) ? clientMenuItems.value : []

  return items
    .filter(item => item && typeof item === 'object')
    .map(item => ({
      label: item.label ?? '',
      type: item.type ?? 'link',
      icon: item.icon ?? null,
      color: item.color ?? null,
      route: item.route ?? null,
      path: item.path ?? null,
      params: item.params ?? null,
      query: item.query ?? null,
      children: Array.isArray(item.children)
        ? item.children.filter(child => child && typeof child === 'object')
        : []
    }))
    .filter(item => item.label)
})

/* ============================================================
   Revisa SafeMenu per veure si hi ha algun Group
   Si login_type és campaign-token, no activa menú especial
============================================================ */
const isMenuEspecial = computed(() => {
  if (hideClientNavigation.value) {
    return false
  }

  if (!safeMenu.value.length) {
    return false
  }

  const sessionStr = localStorage.getItem('clientSession')

  if (sessionStr) {
    try {
      const session = JSON.parse(sessionStr)

      if (session.client_idFill !== null && session.client_idFill !== undefined) {
        menuStats.value = 0
        return false
      }
    } catch {
      return false
    }
  }

  return safeMenu.value.some(item => item.type === 'group')
})

watch(isMenuEspecial, value => {
  menuEspecial.value = value ? 1 : 0
})

/* ============================================================
   Funció de navegació
============================================================ */
function toRoute(item) {
  if (!item || typeof item !== 'object') {
    return undefined
  }

  if (item.route) {
    return {
      name: item.route,
      params: item.params || {},
      query: item.query || {}
    }
  }

  if (item.path) {
    return {
      path: item.path,
      query: item.query || {}
    }
  }

  return undefined
}

/* ============================================================
   Genera ID únic per evitar errors de Vuetify
============================================================ */
function itemValue(item, parent) {
  const base = item?.route
    ? `route:${item.route}`
    : item?.path
      ? `path:${item.path}`
      : `label:${item?.label || ''}`

  const shop = item?.params?.shop ?? ''
  const desc = item?.params?.desc ?? ''
  const parentKey = parent?.label ? `:${parent.label}` : ''

  return `${base}${parentKey}${shop ? `:${shop}` : ''}${desc ? `:${desc}` : ''}`
}

/* ============================================================
   Logout de l'usuari
============================================================ */
const logout = () => {
  const redirectPath = userRole.value === 'client' ? '/cliente' : '/'

  localStorage.clear()

  userRole.value = ''
  isCampaignTokenLogin.value = false
  clientMenuItems.value = []
  menuEspecial.value = 0
  menuStats.value = 1
  drawer.value = false

  router.push(redirectPath)
}

/* ============================================================
   Obtenció info client del localStorage
============================================================ */
function getClientOdooIdFromSession() {
  const sessionStr = localStorage.getItem('clientSession')

  if (!sessionStr) {
    return 0
  }

  try {
    const session = JSON.parse(sessionStr)

    return session?.odoo_id
      ?? session?.clientId
      ?? session?.client_id
      ?? 0
  } catch {
    return 0
  }
}

/* ============================================================
   Carrega menú del backend
============================================================ */
async function loadClientMenu(odooId) {
  if (!odooId || hideClientNavigation.value) {
    clientMenuItems.value = []
    menuEspecial.value = 0
    menuStats.value = hideClientNavigation.value ? 0 : 1
    drawer.value = false
    return
  }

  const nocache = import.meta.env.DEV ? '?nocache=1' : ''

  const res = await fetch(`/api/client/${odooId}/menu${nocache}`)

  if (!res.ok) {
    console.error('Error carregant menú', res.status, await res.text())
    clientMenuItems.value = []
    return
  }

  const data = await res.json().catch(error => {
    console.error('JSON invàlid', error)
    return null
  })

  clientMenuItems.value = Array.isArray(data?.menu) ? data.menu : []
}

/* ============================================================
   Lifecycle: càrrega inicial
============================================================ */
function applyClientSessionFromStorage() {
  const session = localStorage.getItem('clientSession')

  if (!session) {
    userRole.value = 'client'
    logo_client.value = '/images/traycco_blanc_p.png'
    sessionShopId.value = ''
    isCampaignTokenLogin.value = isCampaignTokenRoute.value

    if (hideClientNavigation.value) {
      menuEspecial.value = 0
      menuStats.value = 0
      drawer.value = false
      clientMenuItems.value = []
    }

    return 0
  }

  try {
    const sessionData = JSON.parse(session)

    userRole.value = sessionData.role || 'client'
    logo_client.value = sessionData.logo || '/images/traycco_blanc_p.png'

    sessionShopId.value = sessionData.IdBotiga
      ? String(sessionData.IdBotiga)
      : ''

    isCampaignTokenLogin.value = sessionData.login_type === 'campaign-token'

    if (hideClientNavigation.value) {
      menuEspecial.value = 0
      menuStats.value = 0
      drawer.value = false
      clientMenuItems.value = []
    }
  } catch (error) {
    console.error('Error llegint clientSession', error)

    userRole.value = 'client'
    logo_client.value = '/images/traycco_blanc_p.png'
    sessionShopId.value = ''
    isCampaignTokenLogin.value = isCampaignTokenRoute.value
  }

  return getClientOdooIdFromSession()
}

watch(
  () => route.fullPath,
  async () => {
    const odooId = applyClientSessionFromStorage()
    await loadClientMenu(odooId)
  },
  { immediate: true }
)

onMounted(() => {
  const savedTheme = localStorage.getItem('theme') || 'light'
  theme.global.name.value = savedTheme

  router.onError(error => console.error('Router error:', error))

  window.addEventListener('scroll', handleScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

watch(() => theme.global.name.value, value => {
  localStorage.setItem('theme', value)
})
</script>

<style scoped>
.header-bar {
  background-color: transparent !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  transition: transform 0.3s ease;
  z-index: 20 !important;
}

/* Logo del client */
.client-logo-wrapper {
  position: absolute;
  top: 0;
  left: 40px;
  background-color: var(--color-backgroundnegative);
  width: 520px;
  height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 85px 85px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.client-logo {
  max-width: 100%;
  max-height: 70px;
  object-fit: contain;
}

.menu-link {
  color: var(--color-text) !important;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  min-width: unset;
  padding: 6px 12px;
}

.menu-link:hover {
  text-decoration: underline;
}

.active-link {
  border-bottom: 2px solid #00aaff;
}

.gap-buttons > * {
  margin-left: 8px;
}

.footer-bar {
  background-color: #ffffff !important;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  color: inherit;
}

:deep(.v-theme--dark) .footer-bar .footer-link {
  color: #1a1919 !important;
  opacity: 0.9;
}

:deep(.v-theme--dark) .footer-bar .footer-link:hover {
  opacity: 1;
  text-decoration: underline;
}

.footer-content {
  min-height: 72px;
}

.footer-logo {
  max-height: 40px;
  max-width: 180px;
  object-fit: contain;
  opacity: 0.9;
}

.footer-link {
  font-weight: 600;
  text-decoration: none;
  color: black;
  opacity: 0.9;
}

.footer-link:hover {
  text-decoration: underline;
  opacity: 1;
}

@media (max-width: 600px) {
  .footer-bar {
    height: auto !important;
  }

  .footer-content {
    padding: 8px 0;
  }

  .footer-link {
    margin-top: 6px;
  }
}

.theme-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  user-select: none;
}

.toggle-label {
  font-weight: 700;
  color: #ffffff90;
  transition: color 0.3s;
  font-size: 12px;
}

.toggle-label.active {
  color: var(--color-primary);
}

.toggle-switch {
  width: 80px;
  height: 28px;
  border: 3px solid var(--color-primary);
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 3px;
  transition: all 0.3s ease-in-out;
}

.toggle-switch.dark {
  background-color: transparent;
  justify-content: flex-end;
}

.toggle-icon {
  color: var(--color-primary) !important;
  font-size: 18px;
}

/* BASE: la capa que conté la imatge */
.header-logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
  background-size: 100% 200px;
  background-repeat: no-repeat;
  background-position: top;
  pointer-events: none;
  z-index: 2;
  filter: opacity(0.1);
}

.theme-light {
  background-color: white !important;
}

.theme-dark {
  background-color: black !important;
}

.theme-dark .header-logo {
  filter: opacity(0.6);
}

.client-menu-drawer {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
